import React, {FC, lazy, ReactElement} from 'react';
import {BrowserRouter, Switch} from 'react-router-dom';
import Route from './Route';

const Main = lazy(() => import('./pages/Main'));
const Search = lazy(() => import('./pages/Search'));

const Router: FC = (): ReactElement => {
    return (
        <BrowserRouter>
            <Switch>
                <Route exact path="/" component={Main}/>
                <Route exact path="/search" component={Search}/>
            </Switch>
        </BrowserRouter>
    );
};

export default Router;
